module.exports = __webpack_public_path__ + "static/media/03_Referenz_5w-50-min-min.2dade52d.jpg";